import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface Option { value: string; label: string; }
interface FieldRowProps {
  label: string;
  id: string;
  value: string;
  onChange: (val: string) => void;
  type?: string;
  placeholder?: string;
  required?: boolean;
  options?: Option[];
  readOnly?: boolean;
  hint?: string;
}

export default function FieldRow({ label, id, value, onChange, type = 'text', placeholder, required, options, readOnly, hint }: FieldRowProps) {
  return (
    <div>
      <label htmlFor={id} className="text-xs text-muted-foreground uppercase tracking-wider mb-1.5 block">
        {label}{required && <span className="text-destructive ml-0.5">*</span>}
      </label>
      {options ? (
        <Select value={value || 'none'} onValueChange={v => onChange(v === 'none' ? '' : v)} disabled={readOnly}>
          <SelectTrigger id={id}><SelectValue placeholder={`Select ${label.toLowerCase()}`} /></SelectTrigger>
          <SelectContent>
            {!required && <SelectItem value="none">Not specified</SelectItem>}
            {options.map(o => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
          </SelectContent>
        </Select>
      ) : (
        <Input id={id} type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} readOnly={readOnly} className={readOnly ? 'opacity-60 cursor-not-allowed' : ''} />
      )}
      {hint && <p className="text-xs text-muted-foreground mt-1">{hint}</p>}
    </div>
  );
}
